export default {"src":"/_next/static/media/dashboard.9c626a4f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};